<!--topbar -->
<div class="row bg-dark" *ngIf="!isAbout && !istherapies " >
    <div class="col text-right">
        <a class="mr-3"><i class="fa fa-calendar ttm-btn ttm-btn-size-md mr-2"></i>Dincharya</a>
        <a><i class="fa fa-envelope-o ttm-btn ttm-btn-size-md ttm-btn-bgcolor-whitecolor pl-3 mr-2"></i></a>
        <a><i class="fa fa-facebook ttm-btn ttm-btn-size-md ttm-btn-bgcolor-whitecolor mr-2"> </i></a>
        <a><i class="fa fa-twitter ttm-btn ttm-btn-size-md ttm-btn-bgcolor-whitecolor mr-2"> </i> </a>
        <a><i class="fa fa-youtube ttm-btn ttm-btn-size-md ttm-btn-bgcolor-whitecolor mr-2"> </i> </a>
        <a><i class="fa fa-instagram ttm-btn ttm-btn-size-md ttm-btn-bgcolor-whitecolor mr-2"> </i></a>

        <a class="ml-3 ttm-btn ttm-btn-size-md">Book Now</a>
    </div>
    <div class="ttm-topbar-content topbar-expand-md topbar-dark bg-dark fixed-top container-fluid">
        <div class="row justify-content-end">


        </div>
    </div>
</div>


<!--second-topbar -->
<div class="ttm-header-wrap ttm-bgcolor-whiteecolor" *ngIf="!isAbout && !istherapies " >
    <div class="container ">
        <div class="row ttm-bgcolor-whiteecolor ">
            <div class="col-lg-3  text-center column-divider ttm-bgcolor-whiteecolor"> <!-- Add column-divider -->
                <div class="widget-left clearfix">
                    <div class="info-widget">
                        <div class="info-widget-content mt-2">
                            <p><strong>For Booking Assistance</strong></p>
                            <h2>+91 9607095588<br>+91 2026926230</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6  text-center column-divider ttm-bgcolor-whiteecolor">
                <!-- Add column-divider-->

                <div class="widget-left clearfix d-flex justify-content-center align-items-center">
                    <!-- Add d-flex justify-content-center align-items-center classes -->
                    <div class="site-branding mt-2">
                        <a class="home-link" title="NISARGOPCHAR GRAMSUDHAR TRUST" rel="home">
                            <img id="logo-img" class="img-center"
                                src="https://www.narayandhamcare.com/assets/images/logo-white-1.png" alt="logo-img">
                            <!-- ashram_logo-->
                        </a>
                    </div>
                </div>

            </div>
            <div class="col-lg-3 text-center ttm-bgcolor-whiteecolor column-divider"> <!-- Add column-divider  -->
                <div class="widget-left clearfix">
                    <div class="info-widget">
                        <div class="info-widget-content mt-2 text-center">
                            <p><strong>Request an</strong></p>
                            <h2>Get Appointment</h2>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>


<!--NAv-BAR -->
<div id="navbar-sticky" class="row justify-content-center ttm-bgcolor-whiteecolor sticky-top">
    <nav class="navbar navbar-expand-lg mt-3 ttm-bgcolor-whiteecolor ">
        <div class="collapse navbar-collapse text-center" id="navbarSupportedContent">
            <div class="site-header-menu-inner ttm-stickable-header ">
                <ul class="navbar-nav mr-auto text-expand-lg">
                    <li class="nav-item active mr-2 ">
                        <a class="nav-link" href="#" (click)="navigateToHome()"><strong>HOME</strong></a>
                    </li>

                    <li class="nav-item dropdown active mr-3">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><strong>ABOUT
                                US</strong></a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" (click)="GetAboutDetails('History');">HISTORY</a>
                            <a class="dropdown-item" (click)="GetAboutDetails('Objectofthetrust');">OBJECTIVE OF THE TRUST</a>
                            <a class="dropdown-item" (click)="GetAboutDetails('Trustees');">TRUSTEES</a>
                            <a class="dropdown-item" (click)="GetAboutDetails('Doctors');">DOCTORS</a>
                            <a class="dropdown-item" (click)="GetAboutDetails('AdayAtAshram');">A DAY AT ASHRAM</a>
                            <a class="dropdown-item" (click)="GetAboutDetails('ThingstoCarry');">THINGS TO CARRY</a>
                            <a class="dropdown-item" (click)="GetAboutDetails('Rules');">RULES AND REGULATIONS</a> 
                            <a class="dropdown-item" (click)="GetAboutDetails('Location');">LOCATION</a>  
                            <a class="dropdown-item" (click)="GetAboutDetails('NatureCure');">NATURE CURE</a>
                            <a class="dropdown-item" (click)="GetAboutDetails('Testimonials');">TESTIMONIALS</a>
                            <a class="dropdown-item" (click)="GetAboutDetails('Workshops');">WORKSHOPS/SEMINARS</a>
                        </div>
                    </li>
                    <li class="nav-item dropdown active mr-3">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                            data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false"><strong>THERAPIES</strong></a>

                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" (click)="GettherapiesDetails('treatmentphilosopy');">TREATMENT PHILOSOPY</a>
                            <a class="dropdown-item" (click)="GettherapiesDetails('treatments');">TREATMENTS</a>
                        </div>
                    </li>
                    <li class="nav-item dropdown active mr-3">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                            data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false"><strong>FACILITIES</strong></a>

                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="#">SERVICES</a>
                            <a class="dropdown-item" href="#">ONLINE YOGA</a>
                        </div>
                    </li>
                    <li class="nav-item active mr-3">
                        <a class="nav-link" (click)="GettariffDetails('tariff');"><strong>TARIFF</strong></a>
                    </li>
                    <li class="nav-item active mr-3">
                        <a class="nav-link" href="#"><strong>GALLERY</strong> <span class="sr-only">(current)</span></a>
                    </li>
                    <li class="nav-item dropdown active mr-3">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><strong>CONTACT
                                US</strong></a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="#">CONTACT</a>
                            <a class="dropdown-item" href="#">DOWNLOAD</a>
                        </div>
                    </li>
                    <li class="nav-item active mr-3">
                        <a class="nav-link" href="#"><strong>APPLY FOR ADMISSION</strong> <span
                                class="sr-only">(current)</span></a>
                    </li>
                </ul>
            </div>

        </div>
    </nav>
</div>

<!--IMAGE-SLIDE -->

<div class="row  ttm-bgcolor-whiteecolor" *ngIf="!isAbout && !istherapies " >
    <div id="carouselExampleIndicatorss" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators ">
            <li data-target="#carouselExampleIndicatorss" data-slide-to="0" class="active"></li>
            <li data-target="#carouselExampleIndicatorss" data-slide-to="1"></li>
            <li data-target="#carouselExampleIndicatorss" data-slide-to="2"></li>
        </ol>
        <div class="carousel-inner" role="listbox">
            <div class="carousel-item  active">
                <img class="w-100 img-fluid" src="assets/img/carousel-slider-2.jpg" alt="First slide" width="1520"
                    height="833">
                <div class="carousel-caption d-none d-md-block">
                    <h3 class="mb-10" style="max-width:100%; color: aliceblue; font: bold; font-size:xx-large;">
                        NISARGOPCHAR GRAMSUDHAR TRUST</h3>
                    <p>Established by Father of Nation Mahatma Gandhiji in the year 1946<br>(Completed
                        75 years
                        of serving humanity)</p>
                </div>
            </div>
            <div class="carousel-item">
                <img class="w-100 img-fluid" src="assets/img/carousel-slider-1.jpg" alt="second slide" width="1520"
                    height="833">
                <div class="carousel-caption d-none d-md-block">
                    <h3 class="mb-10" style="color: aliceblue; font: bold; font-size:xx-large;">NATURE CURE</h3>
                    <p style="font-size: medium;"> It is the health which is real wealth and not pieces of gold
                        and silver</p>
                </div>
            </div>
            <div class="carousel-item">
                <img class="w-100 img-fluid" src="assets/img/carousel-slider-3.jpg" alt="Third slide" width="1520"
                    height="833">
                <div class="carousel-caption d-none d-md-block">
                    <h3 class="mb-10" style="color: aliceblue; font: bold; font-size:xx-large;">FIVE ELEMENTS
                    </h3>
                    <p style="font-size: medium;"> The programs focus on physical, mental and emotional
                        detoxification, using natural methods such as raw food diet, juice diet,
                        fasting, exercise, steam bath, hydrotherapy, enemas, counselling, and meditation</p>
                </div>
            </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleIndicatorss" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleIndicatorss" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
</div>
<!-- INFORMATION -->

<section class="ttm-row  clearfix mt- 5 ttm-bgcolor-whiteecolor" *ngIf="!isAbout && !istherapies && !istariff" >
    <div class="container ttm-bgcolor-whiteecolor ">
        <div class="row">

            <div class="col-lg mt-5">

                <div class="section-title mb-35 clearfix">
                    <!-- section title -->
                    <div class="title-header info-widget-content">
                        <h1 class="title text-left " style="font-size: 25px;">Welcome to Shree Narayan Dham Naturopathy
                            Center in Pune </h1>
                        <h5 class=" title">---Nature care, yog ayurvedic treatment center for your healthy body</h5>
                    </div>


                    <div class="title-desc para-color" style="text-align:justify;">
                        <h3>
                            Nisargopchar Ashram, Urulikanchan established by Mahatma Gandhiji has a legacy of 75 years
                            in treatment of
                            various ailments through the principles of Naturopathy; We treat sadhkas with individualized
                            treatments and diet based on their condition.
                            Our therapies are based on five great elements of nature which are known for its immense
                            healing properties.</h3>
                        <a href="https://nisargopcharashram.org/history/"> <i>Read More...</i></a>
                    </div>


                </div><!-- section title end -->



            </div>

            <div class="col-lg-6 col-sm-12 mt-5 ttm-bgcolor-whiteecolor">
                <div class="pl-371 res-991-pl-011">
                    <div class="section-title mb-35 clearfix">
                        <div class="embed-responsive embed-responsive-16by9">
                            <iframe class="embed-responsive-item"
                                src="https://www.youtube.com/embed/bPhmq96A8r8?autoplay=1&amp;loop=1&amp;playlist=bPhmq96A8r8"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen=""></iframe>
                        </div>

                    </div>
                </div>
                <div class="col-lg mt-5 mb-5"></div>

            </div><!-- row end -->
        </div>
    </div>
</section>

<!-- images-->

<div class="container-fluid mt-5 ttm-bgcolor-grey " *ngIf="!isAbout && !istherapies && !istariff" >
    <div class="row mt-4 ttm-bgcolor-grey">

        <div class="col-lg mt-3 mb-3"></div>
        <div class="col-lg mt-5 mb-5  text-center"> <!-- Add column-divider -->
            <div class="widget-left clearfix">
                <div class="ttm-process-image">

                    <img class="img-fluid rounded-circle border-white" src="assets/img/naturopathy-2.jpg"
                        alt="step-three" title="Acupuncture"
                        style="border-style: solid;border: 10px solid #fff;width: 162px;height: 162px;">

                    <div class="featured-content">
                        <div class="featured-title text-center mt-3 mr-3 font-size-xxlg">
                            <h3><strong>Naturopathy</strong></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg mt-5 mb-5  text-center"> <!-- Add column-divider -->
            <div class="widget-left clearfix">
                <div class="ttm-process-image">
                    <img class="img-fluid rounded-circle border-white" src="assets/img/about-yoga.png" alt="step-three"
                        title="Acupuncture"
                        style="border-style: solid;border: 10px solid #fff;width: 162px;height: 162px;">
                    <div class="featured-content">
                        <div class="featured-title text-center mt-3 mr-3 font-size-xxlg">

                            <h3><strong>Yoga</strong></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg mt-5 mb-5  text-center"> <!-- Add column-divider -->
            <div class="widget-left clearfix">
                <div class="ttm-process-image">

                    <img class="img-fluid rounded-circle border-white" src="assets/img/ayurveda-1.png" alt="step-three"
                        title="Acupuncture"
                        style="border-style: solid;border: 10px solid #fff;width: 162px;height: 162px;">
                    <div class="featured-content">
                        <div class="featured-title text-center mt-3 mr-3 font-size-xxlg">
                            <h3><strong>Ayurveda</strong></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg mt-5 mb-5  text-center"> <!-- Add column-divider -->
            <div class="widget-left clearfix">
                <div class="ttm-process-image">

                    <img class="img-fluid rounded-circle border-white" src="assets/img/physiotherapy.jpg"
                        alt="step-three" title="Acupuncture"
                        style="border-style: solid;border: 10px solid #fff;width: 162px;height: 162px;">
                    <div class="featured-content">
                        <div class="featured-title text-center mt-3 mr-3 font-size-xxlg">
                            <h3><strong>Physiotherapy</strong></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg mt-5 mb-5  text-center"> <!-- Add column-divider -->
            <div class="widget-left clearfix">
                <div class="ttm-process-image">

                    <img class="img-fluid rounded-circle border-white" src="assets/img/Diet_therapy.jpg"
                        alt="step-three" title="Acupuncture"
                        style="border-style: solid;border: 10px solid #fff;width: 162px;height: 162px;">
                    <div class="featured-content">
                        <div class="featured-title text-center mt-3 mr-3 font-size-xxlg">
                            <h3><strong>Diet therapy</strong></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg mt-5 mb-5  text-center"> <!-- Add column-divider -->
            <div class="widget-left clearfix">
                <div class="ttm-process-image">

                    <img class="img-fluid rounded-circle border-white" src="assets/img/acupuncture.jpg" alt="step-three"
                        title="Acupuncture"
                        style="border-style: solid;border: 10px solid #fff;width: 162px;height: 162px;">
                    <div class="featured-content">
                        <div class="featured-title text-center mt-3 mr-3 font-size-">
                            <h3><strong>Acupuncture</strong></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg mt-3 mb-3"></div>
    </div>

</div>

<!---OUR-GALLERY-->

<div class="row mt-5 ttm-bgcolor-whiteecolor" *ngIf="!isAbout && !istherapies && !istariff" >
    <div class="col-lg mt-3 mb-"></div>
    <div class="col-md-12">
        <!-- section title -->
        <div class="section-title text-center clearfix">
            <div class="title-header">

                <h2 class="title font-weight: 500;font-size: 38px;line-height: 50px;margin-bottom: 0;">Our Gallery</h2>
            </div>

        </div>
        <div class="col-lg mt-3 mb-3"></div>
    </div>
</div>

<!---image-slide-->
<div class="row  container-fluid ttm-bgcolor-whiteecolor" *ngIf="!isAbout && !istherapies && !istariff" >
    <div class="col">
        <div id="multi-item-carousel" class="carousel slide mt-4 align-items-right" data-ride="carousel">
            <div class="carousel-inner">
                <div class="carousel-item active">

                    <div class="row">
                        <div class="col-md" *ngFor="let image of images.slice(0, 5)">
                            <img [src]="image" class="d-block w-10" alt="Slide">
                        </div>
                    </div>
                </div>

            </div>
            <a class="carousel-control-prev" href="#multi-item-carousel" role="button" data-slide="prev "
                (click)="prevSlide()">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>

            <a class="carousel-control-next" href="#multi-item-carousel" role="button" data-slide="next"
                (click)="nextSlide()">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>

</div>


<div class="row mt-5" *ngIf="!isAbout && !istherapies && !istariff">
    <div class="col-md-12 text-center">
        <div class="mt-50 res-991-mt-30">
            <a class=" btn-design ttm-btn ttm-btn-size-lg ttm-btn.ttm-btn-shape-round ttm-btn-style-border ttm-btn-color-black ml-15 mb-20"
                href="https://www.narayandhamcare.com/gallery">View More</a>



            <a class="btn-design ttm-btn.ttm-btn-shape-round ttm-btn-style-fill ttm-btn-bgcolor-skincolor ml-15 mb-20"
                href="https://www.narayandhamcare.com/contact">Contact Us</a>
        </div>
    </div>
</div>

<!-- green-row -->

<div class="mt-5 ttm-bgcolor-skincolor clearfix " *ngIf="!isAbout && !istherapies && !istariff" >

    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="spacing-2">

                    <div class="title-header md-30 mt-4">
                        <h2 class="section-title mb-35 clearfix d-flex justify-content-start">-Testimonial</h2>

                        <p class="title d-flex justify-content-start" style="font-size: 50px;line-height:90%">What Our
                            Clients Say!</p>
                    </div>
                    <div _ngcontent-xch-c4="" class="testimonial-wrap py-4" dir="ltr">
                        <div _ngcontent-xch-c4="" class="container">
                            <div _ngcontent-xch-c4="" class="testimonial-slider">
                                <div _ngcontent-xch-c4="" class="card shadow-box border p-4">
                                    <ngx-slick-carousel _ngcontent-xch-c4="" ng-reflect-config="[object Object]"
                                        class="slick-initialized slick-slider slick-dotted">
                                        <!-- Add your slides here -->
                                        <div class="row  container-fluid ">
                                            <div class="col">
                                                <div id="multi-item-carousel"
                                                    class="carousel slide mt-4 align-items-right" data-ride="carousel">
                                                    <div class="carousel-inner">
                                                        <div class="carousel-item active">

                                                            <div class="row">
                                                                <div class="col-md"
                                                                    *ngFor="let text of text.slice(0, 1)">
                                                                    <!-- <img [src]="image" class="d-block w-30" alt="Slide"> -->

                                                                    <h1>{{text}}</h1>


                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                    <a class="carousel-control-prev" href="#multi-item-carousel"
                                                        role="button" data-slide="prev " (click)="prevSlide()">
                                                        <span class="carousel-control-prev-icon"
                                                            aria-hidden="true"></span>
                                                        <span class="sr-only">Previous</span>
                                                    </a>

                                                    <a class="carousel-control-next" href="#multi-item-carousel"
                                                        role="button" data-slide="next" (click)="nextSlide()">
                                                        <span class="carousel-control-next-icon"
                                                            aria-hidden="true"></span>
                                                        <span class="sr-only">Next</span>
                                                    </a>
                                                </div>
                                            </div>

                                        </div>
                                        <ul class="slick-dots" role="tablist">
                                            <!-- Dot indicators for slides -->
                                            <li class="" role="presentation"><button type="button" role="tab"
                                                    id="slick-slide-control30" aria-controls="slick-slide30"
                                                    aria-label="1 of 3" tabindex="-1">1</button></li>
                                            <li role="presentation" class=""><button type="button" role="tab"
                                                    id="slick-slide-control31" aria-controls="slick-slide31"
                                                    aria-label="2 of 3" tabindex="-1">2</button></li>
                                            <li role="presentation" class="slick-active"><button type="button"
                                                    role="tab" id="slick-slide-control32" aria-controls="slick-slide32"
                                                    aria-label="3 of 3" tabindex="0" aria-selected="true">3</button>
                                            </li>
                                        </ul>
                                    </ngx-slick-carousel>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!---image-->

<section class="ttm-row home3-row-title-section bg-img7 ttm-bg clearfix" *ngIf="!isAbout && !istherapies && !istariff" >
    <div class="container"><!--container-->
        <div class="row"><!--row-->
            <div class="col-lg-12 text-center">
                <!-- section title -->
                <div class="row-title style5 clearfix">

                    <div class="title-header">
                        <h2 class="title mb-15">There is no medicine <span class="ttm-textcolor-skincolor">medicine
                            </span> <br> you can take that will replace what you can do for your own <span
                                class="ttm-textcolor-skincolor">health.!</span></h2>
                        <div class="mt-50 res-991-mt-30">
                            <a class="btn-design ttm-btn.ttm-btn-shape-round ttm-btn-style-fill ttm-btn-bgcolor-skincolor ml-15 mb-20"
                                href="#">Contact Us</a>
                        </div>

                    </div>
                </div><!-- section title end -->

            </div>
        </div>
    </div>
</section>

<div *ngIf="isAbout;">
    <app-about [isHistory]="isHistory" [isObjectofthetrust]="isObjectofthetrust" [isTrustees]="isTrustees" [isDoctors]="isDoctors" [isAdayAtAshram]="isAdayAtAshram" 
    [isThingstoCarry]="isThingstoCarry" [isRules]="isRules" [isLocation]="isLocation"  [isNatureCure]="isNatureCure"  [isTestimonials]="isTestimonials" [isWorkshops]="isWorkshops"
     ></app-about>
</div>
<div *ngIf="istherapies;">
    <app-therapies [istreatmentphilosopy]="istreatmentphilosopy" [istreatments]="istreatments"  ></app-therapies>
</div>
<div *ngIf="istariff;">
    <app-tariff  [istariff]="istariff"></app-tariff>
</div>

<!------Footer---->

<div class="second-footer ttm-textcolor-white footer-dark bg-dark container-fluid">
    <div class="container">

        <div class="row">
            <div class="col-lg ">
                <div class="row mt-5">
                    <h1 class="text-white">
                        About Us
                    </h1>
                </div>
                <div class="row">
                    <ul>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white"
                                href="https://www.narayandhamcare.com/about">Our Inspiration</a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white"
                                href="https://www.narayandhamcare.com/about">Objectives Of The Trust</a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white"
                                href="https://www.narayandhamcare.com/about-pune">Trustees </a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white" target="_BLANK">Doctors</a>
                        </li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white"
                                href="https://www.narayandhamcare.com/dincharya">A day at Ashram</a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white"
                                href="https://www.narayandhamcare.com/dincharya">Things to Carry</a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white"
                                href="https://www.narayandhamcare.com/dincharya">Rules and Regulations</a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white"
                                href="https://www.narayandhamcare.com/dincharya">Location</a></li>


                    </ul>
                </div>

            </div>

            <div class="col-lg ">
                <div class="row mt-5">
                    <h1 class="text-white">
                        Quick Links
                    </h1>
                </div>
                <div class="row">
                    <ul>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white">Treatment Philosophy</a>
                        </li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white">Treatments</a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white">Workshops / Seminars</a>
                        </li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white">Nature Cure</a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white">Tariff</a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white">Blog</a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white">Contact</a></li>
                        <li class="mt-3"><a class="d-flex justify-content-start text-white">Donation</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg ">
                <div class="row mt-5">
                    <h1 class="text-white">
                        Contact Info
                    </h1>
                </div>
                <div class="row">
                    <ul class="ttm-list ttm-list-style-icon text-white mt-2">
                        <i class="fa fa-envelope-o"></i><a href="mailto:info@narayandhamcare.com"> <span
                                class="ttm-list-li-content text-white"> info@narayandhamcare.com</span> </a>
                    </ul>
                    <ul class="ttm-list ttm-list-style-icon text-white mt-2">
                        <li><i class="fa fa-phone"></i><a href="tel:+91 9049592220"> <span
                                    class="ttm-list-li-content text-white"> +91 9049592220</span> <a
                                    class="text-white">| </a> <a href="tel:+91 7875313004 " class="text-white">+91
                                    7875313004</a></a> </li>
                        <li><i class="fa fa-phone"></i><a href="tel:+91 20 2692 6298"> <span
                                    class="ttm-list-li-content text-white"> +91 20 2692 6298</span> <a
                                    class="text-white">| </a> <a href="tel:+91 20 2692 6230 " class="text-white">+91 20
                                    2692 6230</a></a> </li>
                    </ul>

                </div>
            </div>

        </div>
    </div>
    <hr>
    <div class="footer ttm-textcolor-white footer-black-dark bg-dark mt-3"
        style="display: flex; justify-content: space-between;">
        <div class="col">
            © Copyright 2022 Nisargopchar Ashram - All Rights Reserved.
        </div>
        <div class="col text-right">
            Designed & Developed by Mighty Mente | Sitemap
        </div>
    </div>
</div>


